/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       SettingsImage.tsx
 * @author     Christian Ascone
 * @date       10/4/19 6:17 PM
 */

import React from 'react';
import {Image} from "react-native";

export function SettingsImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/settings.png')
            }
        />
    );
}